import { TextField, styled } from "@mui/material";

export const TextFieldStyle = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    border: "1px solid rgba(63, 69, 85, 1)",
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.main,
  },
}));
